import script from "./PopupRecentTrips.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupRecentTrips.vue?vue&type=script&setup=true&lang=js"

import "./PopupRecentTrips.vue?vue&type=style&index=0&id=47197397&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47197397"]])

export default __exports__